module.exports = __webpack_public_path__ + "static/img/hjjc01.993ac59.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hjjc01.png
// module id = 8P+n
// module chunks = 1